import { Configuration } from '@azure/msal-browser';

export enum EnvType {
    prod = 'prod',
    hotfix = 'hotfix',
    acc = 'acc',
    dev = 'dev',
    lcl = 'lcl',
}

interface MsalProtectedResources {
    RaxBFFApi: RaxBFFApi;
}

interface RaxBFFApi {
    endpoint: string;
    scopes: string[];
}

interface MsalB2BPolicies {
    names: MsalB2BPoliciesNames;
    authorities: MsalB2BPoliciesAuthorities;
    authorityDomain: string;
}

interface MsalB2BPoliciesNames {
    signUpSignIn: string;
    editProfile: string;
    passwordReset: string;
}

interface MsalB2BPoliciesAuthorities {
    signUpSignIn: MsalB2BPoliciesAuthority;
    editProfile: MsalB2BPoliciesAuthority;
    passwordReset: MsalB2BPoliciesAuthority;
}

interface MsalB2BPoliciesAuthority {
    authority: string;
}

export interface IEnvironment {
    production: boolean;
    envName: string;
    bffApiUrl: string;
    bffSignalApiUrl: string;
    bffSignalNegotiateVersion: number;

    msalConfig: Configuration;
    msalProtectedResources: MsalProtectedResources;
    msalB2BPolicies: MsalB2BPolicies;
}
